import { Table } from "./table";
import { useCounterpartiesTable } from "./use-counterparties-table";

export function CounterpartiesTable({
  tableName,
  type,
  showImportButton = true,
}: {
  tableName: string;
  type: "creditor" | "debtor";
  showImportButton?: boolean;
}) {
  const table = useCounterpartiesTable({
    tableName,
    type,
    showImportButton,
  });

  return <Table {...table} />;
}
